// pages/Contact.js
import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import '../styles/ContactPyrrus.css';

const ContactPyrrus = () => {
  const ceoInfo = {
    name: "Pyrrus KOUDJOU",
    function: "CEO & Co-Fondateur", 
    company: "GUIRETTE SAS",
    phone: "+33605625510",
    address: "13013 Marseille, France",
    winningMessage: "LA SOLUTION GAGNANTE",
    marketingMessage: "Merci de votre intérêt ! Je suis ravi de vous accueillir dans notre réseau. Ensemble, créons des opportunités exceptionnelles ! 🚀",
    linkedin: "https://www.linkedin.com/company/guirette/",
    facebook: "https://www.facebook.com/share/16TEncfEqF/",
    email: "pyrruskoudjou@guirette.net"
  };

  // Générer l'URL WhatsApp pour envoyer un message au CEO
  const generateWhatsAppUrl = () => {
    const message = `
*Message automatique - guirette.net*

Bonjour ! 👋

Vous venez de scanner le QR Code de :

*${ceoInfo.name}*
_${ceoInfo.function}_
🏢 ${ceoInfo.company}

🌟 *${ceoInfo.winningMessage}* 🌟

${ceoInfo.marketingMessage}

📞 *Contact direct:* ${ceoInfo.phone}
📧 *Email:* ${ceoInfo.email}
📍 *Adresse:* ${ceoInfo.address}

🌐 *Réseaux:*
🔗 LinkedIn: ${ceoInfo.linkedin}
📘 Facebook: ${ceoInfo.facebook}

💼 *Message envoyé via QR Code*
🚀 *Innovation • Excellence • Résultats*

_Prêt à collaborer ? Répondez à ce message !_
    `.trim();

    const encodedMessage = encodeURIComponent(message);
    const cleanPhone = ceoInfo.phone.replace(/\D/g, '');
    
    return `https://wa.me/${cleanPhone}?text=${encodedMessage}`;
  };

  const whatsappUrl = generateWhatsAppUrl();

  return (
    <div className="contact-page">
      <div className="container">
        <div className="contact-header">
          <h1>👑 Contact du CEO</h1>
          <p className="subtitle">Scannez pour recevoir mes coordonnées directement sur WhatsApp</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-card">
              <div className="contact-avatar">
                <div className="avatar-placeholder">
                  <span>👑</span>
                </div>
                <div className="online-status">
                  <span className="status-dot"></span>
                  CEO Disponible
                </div>
              </div>
              
              <div className="contact-details">
                <h2>{ceoInfo.name}</h2>
                <p className="function">{ceoInfo.function}</p>
                <p className="company">{ceoInfo.company}</p>
                
                <div className="contact-items">
                  <div className="contact-item">
                    <span className="icon">📞</span>
                    <span className="text">{ceoInfo.phone}</span>
                  </div>
                  
                  <div className="contact-item">
                    <span className="icon">📧</span>
                    <span className="text">{ceoInfo.email}</span>
                  </div>
                  
                  <div className="contact-item">
                    <span className="icon">📍</span>
                    <span className="text">{ceoInfo.address}</span>
                  </div>
                </div>

                <div className="winning-message">
                  <h3>🎯 {ceoInfo.winningMessage}</h3>
                  <p>{ceoInfo.marketingMessage}</p>
                </div>

                <div className="social-links">
                  <a href={ceoInfo.linkedin} target="_blank" rel="noopener noreferrer" className="social-link linkedin">
                    <span>💼</span>
                    LinkedIn CEO
                  </a>
                  <a href={ceoInfo.facebook} target="_blank" rel="noopener noreferrer" className="social-link facebook">
                    <span>👥</span>
                    Facebook
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="qr-section">
            <div className="qr-card">
              <h3>📱 QR Code CEO</h3>
              <p>Scannez pour recevoir mes coordonnées complètes sur WhatsApp</p>
              
              <div className="qr-container">
                <QRCodeSVG 
                  value={whatsappUrl}
                  size={200}
                  level="H"
                  includeMargin={true}
                  fgColor="#25D366"
                  bgColor="#ffffff"
                />
                <div className="qr-overlay">
                  <div className="ceo-icon">👑</div>
                </div>
              </div>
              
              <div className="qr-features">
                <div className="feature">
                  <span>👑</span>
                  <span>Contact direct du CEO</span>
                </div>
                <div className="feature">
                  <span>📋</span>
                  <span>Coordonnées complètes</span>
                </div>
                <div className="feature">
                  <span>⚡</span>
                  <span>Message instantané</span>
                </div>
              </div>

              <div className="qr-instructions">
                <p><strong>Comment ça marche :</strong></p>
                <ol>
                  <li>Scannez le QR Code avec votre téléphone</li>
                  <li>WhatsApp s'ouvre avec un message pré-rempli</li>
                  <li>Le message contient toutes mes coordonnées</li>
                  <li>Envoyez le message pour sauvegarder mes infos</li>
                </ol>
              </div>

              <div className="whatsapp-info">
                <p>🎯 <strong>Avantage :</strong> Vous recevez toutes mes informations dans votre WhatsApp et pouvez me contacter directement !</p>
              </div>

              <a 
                href={whatsappUrl} 
                className="whatsapp-button"
                target="_blank" 
                rel="noopener noreferrer"
              >
                <span>💬</span>
                Recevoir les coordonnées sur WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* Section avantages */}
        <div className="benefits-section">
          <h3>🎯 Pourquoi scanner ce QR Code ?</h3>
          <div className="benefits-grid">
            <div className="benefit">
              <span>💾</span>
              <h4>Sauvegarde instantanée</h4>
              <p>Recevez et sauvegardez toutes mes coordonnées directement dans WhatsApp</p>
            </div>
            <div className="benefit">
              <span>👑</span>
              <h4>Contact direct CEO</h4>
              <p>Accédez au contact direct du fondateur pour des collaborations stratégiques</p>
            </div>
            <div className="benefit">
              <span>🚀</span>
              <h4>Opportunités exclusives</h4>
              <p>Soyez le premier informé des nouvelles opportunités et partenariats</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPyrrus;